/**
 * Progresso de um projeto, derivado das tarefas — não há coluna no banco.
 *
 * Recebe as tarefas vinculadas ao projeto E as subtarefas delas: subtarefa é trabalho real e
 * ignorá-la faria um projeto de 3 tarefas com 20 subtarefas mostrar progresso em saltos de 33%.
 */
export interface TarefaProgresso {
  id: number | string;
  /** Status da Solicitação, quando é uma (categoria 'solicitacao'). */
  solicitacao_status?: string | null;
  /** Status da tarefa comum, usado quando não há solicitacao_status. */
  status?: string | null;
  vencimento?: string | null;
}

export interface Progresso {
  /** Tarefas que contam para o progresso (exclui canceladas/rejeitadas). */
  total: number;
  concluidas: number;
  /** 0-100, arredondado. 0 quando não há tarefa. */
  pct: number;
  /** Não concluídas cujo vencimento já passou. */
  atrasadas: number;
}

const CONCLUIDOS = new Set(['concluido']);
const DESCARTADOS = new Set(['rejeitado', 'cancelado']);

const situacao = (t: TarefaProgresso): string => t.solicitacao_status || t.status || '';

export const calcularProgresso = (tarefas: TarefaProgresso[], hoje: Date = new Date()): Progresso => {
  // Rejeitada/cancelada sai da conta inteira: não é trabalho pendente nem entrega.
  const validas = tarefas.filter(t => !DESCARTADOS.has(situacao(t)));
  const concluidas = validas.filter(t => CONCLUIDOS.has(situacao(t))).length;

  const inicioDoDia = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()).getTime();
  const atrasadas = validas.filter(t => {
    if (CONCLUIDOS.has(situacao(t)) || !t.vencimento) return false;
    return new Date(`${t.vencimento.slice(0, 10)}T00:00:00`).getTime() < inicioDoDia;
  }).length;

  return {
    total: validas.length,
    concluidas,
    pct: validas.length > 0 ? Math.round((concluidas / validas.length) * 100) : 0,
    atrasadas,
  };
};
